import { h, Component, Prop, State } from '@stencil/core';
import type { ComponentInterface } from '@stencil/core';

@Component({
	tag: 'app-speedbump',
	styleUrl: 'speedbump.scss'
})
export class Speedbump implements ComponentInterface {
	appDialog?: HTMLAppDialogElement;

	@Prop() speedbumpId?: string;

	@State() open = false;
	@State() pendingHref: string | null = null;
	@State() pendingTarget: string | null = null;

	componentDidLoad() {
		document.addEventListener('click', (e: MouseEvent) => {
			// Only handle left-clicks with no modifier keys
			if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

			const path = e.composedPath() as HTMLElement[];
			const link = path.find(
				(node): node is HTMLAnchorElement =>
					node instanceof HTMLAnchorElement && node.classList.contains('speedbump-link')
			);
			if (!link) return;

			// If speedbumpId is set, only trigger for matching links
			const sameId = this.speedbumpId === link.dataset.speedbumpId;
			const noId = !this.speedbumpId && !link.dataset.speedbumpId;
			if (!sameId && !noId) return;

			e.preventDefault();
			this.pendingHref = link.href;
			this.pendingTarget = link.target || null;
			this.open = true;
		});

		// Listen for dialog return
		this.appDialog!.addEventListener('appDialogReturn', ({ detail: returnValue }: CustomEvent<string>) => {
			if (returnValue === 'confirm' && this.pendingHref) {
				if (this.pendingTarget) {
					window.open(this.pendingHref, this.pendingTarget);
				} else {
					window.location.href = this.pendingHref;
				}
			}
			this.open = false;
			this.pendingHref = null;
			this.pendingTarget = null;
		});
	}

	render() {
		return (
			<app-dialog
				ref={e => this.appDialog = e}
				modal
				open={this.open}
				onAppDialogToggled={({ detail: open }) => {
					if (this.open !== open) {
						this.open = open;
					}
				}}
			>
				<slot slot='header' name='header' />
				<slot />
				<footer slot='footer' class="speedbump-footer">
					<form method='dialog'>
						<button class='btn btn-primary' value='confirm'>
							<slot name='confirm'>continue</slot>
						</button>
						<button class='btn btn-primary__inverted' value='cancel'>
							<slot name='cancel'>cancel</slot>
						</button>
					</form>
				</footer>
			</app-dialog>
		);
	}
}